import { render, staticRenderFns } from "./ReturnRecordModal.vue?vue&type=template&id=c736f444"
import script from "./ReturnRecordModal.vue?vue&type=script&lang=js"
export * from "./ReturnRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports